import React, { useState, useCallback } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import CategoryBar from "../components/CategoryBar";
import PortfolioGrid from "../components/PortfolioGrid";
import About from "../components/About";
import Services from "../components/Services";
import InstagramGrid from "../components/InstagramGrid";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollProgress from "../components/ScrollProgress";
import BackToTop from "../components/BackToTop";
import CustomCursor from "../components/CustomCursor";
import LoadingScreen from "../components/LoadingScreen";
import Marquee from "../components/Marquee";

const HomePage = () => {
  const [filter, setFilter] = useState("Todos");
  const [loaded, setLoaded] = useState(false);
  const onDone = useCallback(() => setLoaded(true), []);

  return (
    <>
      {!loaded && <LoadingScreen onDone={onDone} />}
      <CustomCursor />
      <main
        className="bg-black text-white"
        data-testid="home-page"
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 500ms ease" }}
      >
        <ScrollProgress />
        <Nav />
        <Hero />
        <Marquee double />
        <CategoryBar active={filter} onChange={setFilter} />
        <PortfolioGrid filter={filter} />
        <Marquee />
        <About />
        <Services />
        <InstagramGrid />
        <Testimonials />
        <Contact />
        <Footer />
        <BackToTop />
      </main>
    </>
  );
};

export default HomePage;
